import type { ReactElement } from 'react'
import { Button } from 'antd'
import { MousePointerClick } from 'lucide-react'
import {
  CATEGORY_STYLES,
  CATEGORY_DISPLAY_NAMES,
  CATEGORY_DISPLAY_NAMES_PLURAL,
} from '../../../constants/mindmapConfig'
import {
  BannerBar,
  BannerLeft,
  BannerTitle,
  PillsRow,
  CategoryPill,
} from './SelectionBanner.styles'

function getCategoryColor(category: string): string {
  const style = CATEGORY_STYLES[category as keyof typeof CATEGORY_STYLES]
  return style?.iconColor ?? '#9ca3af'
}

function getCategoryLabel(category: string, count: number): string {
  if (count === 1) return CATEGORY_DISPLAY_NAMES[category] ?? category
  return CATEGORY_DISPLAY_NAMES_PLURAL[category] ?? category
}

interface SelectionBannerProps {
  categoryCounts: Map<string, number>
  onChangeSelection?: () => void
}

export function SelectionBanner({
  categoryCounts,
  onChangeSelection,
}: SelectionBannerProps): ReactElement | null {
  if (categoryCounts.size === 0) return null

  const totalCount = Array.from(categoryCounts.values()).reduce((sum, c) => sum + c, 0)

  return (
    <BannerBar className="no-print">
      <BannerLeft>
        <MousePointerClick size={14} color="var(--color-primary, #6e53f9)" />
        <BannerTitle>
          {totalCount} node{totalCount !== 1 ? 's' : ''} selected
        </BannerTitle>
      </BannerLeft>
      <PillsRow>
        {Array.from(categoryCounts.entries()).map(([category, count]) => (
          <CategoryPill key={category} $color={getCategoryColor(category)}>
            {count} {getCategoryLabel(category, count)}
          </CategoryPill>
        ))}
      </PillsRow>
      {onChangeSelection && (
        <Button type="link" size="small" onClick={onChangeSelection}>
          Change selection
        </Button>
      )}
    </BannerBar>
  )
}
